import { useBreadcrumbs } from './useBreadcrumbs';
import { commonStrings } from '../components/StringBundle';


export function useCreateLabel() {
  const crumbs = useBreadcrumbs();

  // Page-level crumb: has a navigable 'to' path and is not a
  // module-level crumb (those carry a deptKey).
  const pageCrumb = crumbs.find((c) => !c.deptKey && c.to);

  if (!pageCrumb) return '';

  return commonStrings.createPrefix + pageCrumb.label;
}
